import { render, staticRenderFns } from "./WorkshopContactCard.vue?vue&type=template&id=61b916f5&scoped=true"
import script from "./WorkshopContactCard.vue?vue&type=script&lang=js"
export * from "./WorkshopContactCard.vue?vue&type=script&lang=js"
import style0 from "./WorkshopContactCard.vue?vue&type=style&index=0&id=61b916f5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61b916f5",
  null
  
)

export default component.exports